export const ResumeIcon = () => {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.1777 24.6689C40.0992 26.058 40.0992 28.942 38.1777 30.3311L37.9795 30.4648L23.6104 39.4814C21.2795 40.9442 18.2503 39.2692 18.25 36.5176L18.25 18.4824C18.2503 15.7308 21.2795 14.0558 23.6104 15.5186L37.9795 24.5352L38.1777 24.6689Z"
        fill="#E5CFAB"
        stroke="black"
        stroke-width="5"
      />
    </svg>
  );
};
